/** Fallback palette for coloring pins by group / greater area when none is set. */
export const PIN_FALLBACK_COLORS = [
  '#3b82f6',
  '#22c55e',
  '#f59e0b',
  '#ef4444',
  '#8b5cf6',
  '#14b8a6',
];

/** Color for items with no group / no greater area. */
export const PIN_UNASSIGNED_COLOR = '#64748b';

/** Pick a deterministic fallback color by index. */
export function fallbackPinColor(index: number): string {
  return PIN_FALLBACK_COLORS[index % PIN_FALLBACK_COLORS.length] ?? PIN_UNASSIGNED_COLOR;
}
